



















import { defineComponent, computed } from '@vue/composition-api'

import { IRecommend } from '@/types/recommend'

type Props = {
  recommends: IRecommend[]
  loading: boolean
}

export default defineComponent({
  name: 'RecommendsTable',
  props: {
    recommends: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const headers = [
      { text: '商品コード', value: 'code' },
      { text: '商品名', value: 'name' },
      { text: '価格', value: 'price' },
      { text: 'カテゴリー', value: 'category' },
      { text: '過去マッチ済', value: 'isMatched' },
      { text: 'ID', value: 'id' },
      { text: 'スコア', value: '_score' },
    ]
    const items = computed(() =>
      props.recommends.map((m, index) => {
        return {
          id: m.id || `master_${index.toString()}`,
          name: m.name,
          code: m.code,
          price: m.price,
          category: m.category || '-',
          isMatched: m.isMatched,
          _score: m._score,
        }
      }),
    )

    return { headers, items }
  },
})
